import * as React from "react";
const SvgFlowChartWLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    viewBox="0 0 185.208 111.125"
    {...props}
  >
    <defs>
      <filter
        id="FlowChartWLogo_svg__a"
        width={1.483}
        height={2.325}
        x={-0.189}
        y={-0.519}
        style={{
          colorInterpolationFilters: "sRGB",
        }}
      >
        <feFlood floodColor="#000" floodOpacity={0.498} result="flood" />
        <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation={3} />
        <feOffset dx={4} dy={4} in="blur" result="offset" />
        <feComposite in="flood" in2="offset" operator="in" result="comp1" />
        <feComposite in="SourceGraphic" in2="comp1" result="fbSourceGraphic" />
        <feColorMatrix
          in="fbSourceGraphic"
          result="fbSourceGraphicAlpha"
          values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
        />
        <feFlood floodColor="#000" floodOpacity={0.498} result="flood" />
        <feGaussianBlur in="fbSourceGraphic" result="blur" stdDeviation={3} />
        <feOffset dx={4} dy={4} in="blur" result="offset" />
        <feComposite in="flood" in2="offset" operator="in" result="comp1" />
        <feComposite in="fbSourceGraphic" in2="comp1" result="comp2" />
      </filter>
    </defs>
    <rect
      width={177.011}
      height={13.568}
      x={3.59}
      y={3.938}
      ry={2.755}
      style={{
        fill: "#d8d8d8",
        strokeWidth: 0.411475,
        fillOpacity: 1,
      }}
    />
    <rect
      width={23.753}
      height={6.183}
      x={10.132}
      y={8.087}
      ry={1.643}
      style={{
        fill: "#969696",
        strokeWidth: 0.264583,
        fillOpacity: 1,
      }}
    />
    <circle
      cx={15.948}
      cy={11.04}
      r={1.25}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.165914,
      }}
    />
    <circle
      cx={22.152}
      cy={11.04}
      r={1.25}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.165914,
      }}
    />
    <circle
      cx={28.398}
      cy={11.04}
      r={1.25}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.165914,
      }}
    />
    <path
      d="M14 46.056h31.988"
      style={{
        fill: "#000",
        fillOpacity: 1,
        stroke: "#000",
        strokeWidth: 0.265,
        strokeDasharray: "1.06,.265",
        strokeDashoffset: 0,
        strokeOpacity: 1,
      }}
    />
    <path
      d="M33.479 31.118h-6.33v44.815h14.905M27.016 60.995h17.066M45.988 46.056h31.987M44.082 60.995h30.082M72.051 46.056h64.982M119.14 46.056l-.067-14.938h15.254M27.148 75.933l-.132 14.265h128.518"
      style={{
        fill: "none",
        fillOpacity: 1,
        stroke: "#000",
        strokeWidth: 0.264999,
        strokeDasharray: "1.06,.264999",
        strokeDashoffset: 0,
        strokeOpacity: 1,
      }}
    />
    <path
      d="M137.033 90.33V74.257h18.5"
      style={{
        fill: "none",
        fillOpacity: 1,
        stroke: "#000",
        strokeWidth: 0.264999,
        strokeDasharray: "1.06,.264999",
        strokeDashoffset: 0,
        strokeOpacity: 1,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={33.479}
      y={25.567}
      ry={3.933}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={33.479}
      y={40.506}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={3.397}
      y={40.506}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={33.479}
      y={55.444}
      ry={3.933}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={63.561}
      y={40.506}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={63.561}
      y={55.444}
      ry={3.933}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={123.724}
      y={25.567}
      ry={3.933}
      style={{
        fill: "#d8b9c9",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={93.642}
      y={40.506}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={123.724}
      y={40.506}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={151.956}
      y={84.515}
      ry={3.933}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={151.956}
      y={68.572}
      ry={3.933}
      style={{
        fill: "#88154f",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <rect
      width={21.206}
      height={11.102}
      x={33.479}
      y={70.382}
      ry={3.933}
      style={{
        fill: "#d8d8d8",
        fillOpacity: 1,
        strokeWidth: 0.128826,
      }}
    />
    <g
      style={{
        filter: "url(#FlowChartWLogo_svg__a)",
      }}
      transform="translate(-148.96 125.658)"
    >
      <rect
        width={74.579}
        height={23.532}
        x={206.901}
        y={-75.638}
        ry={3.132}
        style={{
          fill: "#fff",
          fillOpacity: 1,
          stroke: "#b3b3b3",
          strokeWidth: 0.237,
          strokeDasharray: "none",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYMAAACNCAYAAABVGRbWAAAAw3pUWHRSYXcgcHJvZmlsZSB0eXBl IGV4aWYAAHjabVBBEsMgCLzzij5BWDT4HNukM/1Bn1+MOBPb7ozLBmSD0PF+PenWIaykebNSS0kO rVqlubA00E7mpCefMITiNU+2R5N4Ch4RDWVEnvlomJGbq3w1ekThvhaqhr99GckI6BN1HYNQDSPI KHAYtPGsVKpt1yfcj7TCxqFOauvYP9+bb2/P/h+IHGAkZ0DHAOgHhNYLzoLsF9kvdC3OwDTzhfzb 0wR9ADdcWUYMbEG1AAABhWlDQ1BJQ0MgcHJvZmlsZQAAeJx9kT1Iw0AcxV9TpVIqQq2g4pChOlkQ FXHUKhShQqgVWnUwufRDaNKQtLg4Cq4FBz8Wqw4uzro6uAqC4AeIq4uToouU+L+k0CLGg+N+vLv3 uHsHCPUS06yOMUDTK2YqERcz2RUx8IogBhBGH8Iys4xZSUrCc3zdw8fXuxjP8j735+hWcxYDfCLx DDPMCvE68dRmxeC8TxxhRVklPiceNemCxI9cV1x+41xwWOCZETOdmiOOEIuFNlbamBVNjXiSOKpq OuULGZdVzluctVKVNe/JXxjK6ctLXKc5hAQWsAgJIhRUsYESKojRqpNiIUX7cQ//oOOXyKWQawOM HPMoQ4Ps+MH/4He3Vn5i3E0KxYHOF9v+GAYCu0CjZtvfx7bdOAH8z8CV3vKX68D0J+m1lhY9Anq2 gYvrlqbsAZc7QP+TIZuyI/lpCvk88H5G35QFem+B4KrbW3Mfpw9AmrpK3gAHh8BIgbLXPN7d1d7b v2ea/f0AV/hynKYp2eQAAA14aVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVn aW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pgo8eDp4bXBtZXRhIHhtbG5z Ong9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA0LjQuMC1FeGl2MiI+CiA8cmRm OlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1u cyMiPgogIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICB4bWxuczp4bXBNTT0iaHR0 cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMu YWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiCiAgICB4bWxuczpkYz0iaHR0 cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczpHSU1QPSJodHRwOi8vd3d3 LmdpbXAub3JnL3htcC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYv MS4wLyIKICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIKICAgeG1w TU06RG9jdW1lbnRJRD0iZ2ltcDpkb2NpZDpnaW1wOjZjODU0ZWZiLTQ1NDMtNGFkOS04NzQ5LWJk MGY1YjA5Nzg3NiIKICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZjI0ZWI4OC1hOWE1LTRl NWItYTgyMi05Y2MwZmYyYzE2NmMiCiAgIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRp ZDo1NjBlMWZhYy1mZjIyLTQzMmYtYThlNS1mNzgzNGUxNjdjNzgiCiAgIGRjOkZvcm1hdD0iaW1h Z2UvcG5nIgogICBHSU1QOkFQST0iMi4wIgogICBHSU1QOlBsYXRmb3JtPSJMaW51eCIKICAgR0lN UDpUaW1lU3RhbXA9IjE2OTgyNTgxNjUzNzA2MjYiCiAgIEdJTVA6VmVyc2lvbj0iMi4xMC4zNCIK ICAgdGlmZjpPcmllbnRhdGlvbj0iMSIKICAgeG1wOkNyZWF0b3JUb29sPSJHSU1QIDIuMTAiCiAg IHhtcDpNZXRhZGF0YURhdGU9IjIwMjM6MTA6MjVUMTM6MjI6MzAtMDU6MDAiCiAgIHhtcDpNb2Rp ZnlEYXRlPSIyMDIzOjEwOjI1VDEzOjIyOjMwLTA1OjAwIj4KICAgPHhtcE1NOkhpc3Rvcnk+CiAg ICA8cmRmOlNlcT4KICAgICA8cmRmOmxpCiAgICAgIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiCiAgICAg IHN0RXZ0OmNoYW5nZWQ9Ii8iCiAgICAgIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6NTcyYTlh MjYtOTM3Ny00M2ZlLTg1NzAtMzI4ZjZjODZhODFkIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50 PSJHaW1wIDIuMTAgKExpbnV4KSIKICAgICAgc3RFdnQ6d2hlbj0iMjAyMy0xMC0yNVQxMzoyMjo0 NS0wNTowMCIvPgogICAgPC9yZGY6U2VxPgogICA8L3htcE1NOkhpc3Rvcnk+CiAgPC9yZGY6RGVz Y3JpcHRpb24+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgogICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg ICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgCjw/eHBhY2tldCBlbmQ9InciPz6KdUM7AAAA BmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5woZEhYt5tEfkgAA F5tJREFUeNrtnT9T28gbxx/95urzUMTVWXkDJhRUh0VDumRIclVsU1NkCNAkhplceZkxkAYCQ0Ft 5FRHkiEdNJa5isLYbwA5lVMwvjewv4KsT9ja1UqWLNl8PzPMhGBL2j96nt3n3xIBAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAUCk/eM4OZ5fZtdVk6A0AwCTw y31o5JV5xv793iG73qJUJk2ZuSw9KjzWglzr2moy848/qWt3qNvuDPzd2jEZEZHxtqBhegEAxoWJ F1jHL94xu94a+P+Unqbp/EIgoS0S+OUHz3s7hen8Aj39uA6FAACAMogbp3AWEZbQ5jsGp7J5dXkE ZQAAGAv+N8k7ApXP2RctCsP2/9CY1vRctve7PpfF7AIAYGcQJ/2rdC/0XJaKJ+81les+NKaln7sy z1hQfwQAAMTF2DiQT1d3WbN63vtdZvN3c+zKkH3e2jGZtV0lIiLzjz/pcHaZyXwNXoqAt2MYnwUA ANzLnYHM9m+U8gMCtV9xqLD54/NAX4icz1wZ+fUJuLUDvgUAQBJIvM/Ay/ZvbVcHbP4pPT30fa0d U6gIiIi6dodOV3eZn+uJroN8BQAAlIEHMoHMqX+o3vk987s/5+10fmHg/1R2FvZFS/keXVtsimr/ 08JMBABAGYi4Ms+UVsz9Nv/+yB4vsi8XfAnvIKt62W7l19/SmIkAACgDoQDNqAlJN8GtEh1EdBtJ 5BUhJEP1uyJHcUpPE6KPAABQBiEIWjczD9GtU1i2Ip/OLwiVhp+dhSqFv/+6s0NI6Wl6sruGWQgA iJ3Er0hVIoMKf/8lVRxX5hlrX7So276tJzSdX6DM71nP73xb25Ov9l0imQAAAMogIg5nl5nIhv9k by0yM4szx8Bt56Bqipp0arUas22b2u02ZTIZ0nWdiIjm5+fRP6DHysoKOz4+HlxUGQZ9/foVcyVm Yk86u7aarP1Pi7p2h7IvF1xX668ujzRrx2TN6nnPP8BNLMPY+70w3hY0HmLKo5q8ksV4hVRZe7wU ENGtH2SY6qpRUy6X2dbWFhERPXv2zPUzU1NTzDAMyufztLS0hJc9wWMYNrquU6PRwJhjZ6BGf1LX uGflDtMeUQmNJPVJuVxmpmmSbduBhEOhUKDNzU0IiHuqDLAzSDaxOZCvzLOBpK6u3aFm9TySJKzT 1V12OLvMVMNVR9keWS2lKPvED4uLi2xrayuQIiAism2btra2aGZmBgl2AEAZ/EdbkLDVtTtDJWGJ hD03MbUvWiNvj1etpP6kObdreH0mKmq1GpuammKWZYVyPdu2aWZmhpXLZSgFAKAM5MXhgiRhXZln rPzgOfu2tkeHs8sDgsYo5Smlp10TzKJuj6eAVMiyHub6wygCkT9gWIWwtbVFUAgAJIfYHMjZlwtC IRjEaepcmXftDlk7JnPa2Xv/No4S1R7VctsqGdFxKQJd13s/XNir7CS4QoAfIXk4xzPo9xuNBjoS ysCbR4XHmlvo5pO9NdosfPZ9vcxc9k49oVE7XIO256ExramcyDZqXr9+7fmyc4fwzc2N64uv4qA0 TZNqtRpDGGqy2N/fR2gwlMHoMN4WNJ4QltLTZLwtaDLBKTtc5lHhce9acZ097Lc9PcGay3qaiqbz C0QfP4+kHYuLi1IfAY/+8Fr58RX/zMwMEzmeC4XC0EKHm5va7TbZtk26rtPc3Bzpuh7o2jxvwk0B Oq9Xq9VYvV6ner3eW0UPc19Z2+r1eu8Z+H36w3UrlYrromKSw3rd+ieTyVAmk/HV7lqt5tp3KuO4 uLjISqWS0meHuQ+g25DN8oPnrPzgOTucXWaictBjPal/tk/0M0rz0NTUlPBncXEx0LPMzMyEch2n EOi/ptvPzMwMW1lZ8XWvlZUV12vx65TLZaX7DtM+0TP0/3BhKBs3WR+KviMSWlG0ye9cCHvsZX3n 5deqVCp35oYM0T38zs+oGIvzDJyr5q7dIWu7SlGFiMZFf90iTkpPU+Hvv0b2HNVq1XNHEOS6jUZD 43boL1++BL4OF2CqYa62bdPx8XEoEUy2bfdCbFU+G+SevH1u8fhu8HDdoCG/44afEGfVsZ+fn9cM w3D9m2maSu+LZVkkU6CiXRsRUT6fT0Tfju15Bq1P5xM1yR8a09qryyPtyd7abZJZKU9GKU+vLo+0 KLOsB5SvRAgNmxjUaDS0RqOhBd0Sr6ysBE6S4hFMw6zCLMsiPyG2/J6qq2xVReN2Hy8fz7gzTIgz HwfZDkQkkG3bFo5fpVLpPY9t29KFlOhvYZoUx0YZnK7u9sw8qglUss/FEWo5ivY/KjzWnn5c14y3 BW3UTnDZ6qVYLMbaf6Ls1SDKbtQhrdvb20o7grByOSZREYQR4mxZljDpUeZfEAny/v+X7Q5EY1sq lRLTzyNxIDvDJ/0kUMkibfS5LNHleExmZwXUrt1J7K7m4uJC+LeDg4PYVi+VSoWprHy5GcpLqG5t bVGlUmHDOFZ5NBXRreNapqi4kBCtAFWFna7rZBiGcujuMNTrdeniQEbYDmvVvlEZe9u2aWVlhbnN 52Kx6DqObtd0m5Oi3YFsIZMk5/5IlEG/UFc9tIboNlnMrXJo9uUC0cfxUAZ+2juOBBUaqi+HbGWt 6zqVSiVaWlq6E+JaqVTY9va20LassloXsbGxQZubmwPRVLKXnke7BHkWfr/+EN5arcZev35NUfgL oqpZ5BevyLaNjQ3K5XI0Pz+vOcf+4uJCqKCPj49dlfPBwYHm5nDnpiLn50W7BTfFL3r+YrFIBwcH 92tn4BTqvSxgRUHurBzabXcolUlT7k2eRmlHD0MZ8hyElJ5WCn3l1Vx5u/W5bC9cNarnFE3an45j qTALQyC5OfFkuwIuJJeWloRKReRctW070O6gWCwKi+2JhImXMhD1Oy/2trm56fp3LnC8BOakmoe+ fPniam/nYyrLcxEpYMMwXMfD+XnZc/XvDmTzN5/P31NlwIXYD/KdBXxHAF4S0cn7sZvYd9rvJZR3 zIGs5KZ9a1o6nF1mUZXujjsixe3+spdWJXO50WgIBXSQ3YGXuUwkTIKYwH4mfnle4+vXr5oshHRc kTlkRYrAyebmpiZSCCLTXT6fdx0/59z0mjfO74tMr4ZhJC634H8EEsXxi3fCA3WIbn0O39b3Iqli KgqvS5qCIPLneAurXSrlGXK5nK92hCUs4nbwR/IuCMw8xWJRuW9kCwa33Zpop2jbNpXLZVar1Ziq X0LWhqSEk8ayM/ASgKqHx0wyfuoUfVvfi10gh42fejbb29ukmqwken6/7Rqm3o7fZ8jlclLTnJtw CSPaahyYm5vzZV4R7dZEpruNjQ1Xn4lpmlJzX//uQGamSmJW+EiUQX/ROA6PsnFLKjucXWavLo8m UiFYOyb79bf0QAE7P1FGXbsjLc8RhFwuJ9wij6J+UP/KW2ZCCctG7qddwxRu86skMpmMr+vMz8+H aioqFos0NzcX6LtuPpwg4yKyy/sVpKJ5LdtNiBzJqgsIntsg6tsk+QpGpgwOZ5eZm3D3WgV37Q6d ru6yuOoMRcXp6m7PkdwvzG2fZy0Mc+6DXwEks9+WSiVqt9tK96jX68IX0++Kb5KJQvH4IZ/PJ7Je jq7rdHNzE8q8lgl2P74fXdd97TLjDNOOVRmkMmnq2p2BvACVVTA/4WucIoc8J6ajump/u/yWqQ67 rPXS0pJwdSmLlfezUpOtXvuvE7dAHJVwcxMkquYIlZX0OCLa6QTZpcr8MiKzX6lUUlYGjUZDU43o SuquYCTKoHjyXnMT6HZEJ44lnZ5pyCWqKKWnfQn4zFw29FwLUeJNGCUP/IZAykwfYTlMk1ot0q8y uC+1iYL0TRBfyvz8vJKA58JdVXkkLZx0pMrAbQXsa/U7ZmUnwthF+VYsISKLlZdlb3rhlUW8v7/v y9acVDOGX8Ly08jMeOOKX8ev33nnZZYUhZm6mXxUlUeS52xsoaWqWblRCLykUjx5r9xWPZeN7jkk q25eBdLvjkCmCHRdF5qaRGGhfnIEarVaYsoEuykDkeJVbaOzYNokIQq/5JE6KteQzTsv86bX3/vf E69w5/39/UT3d2zKIPfGO842SoGX2NVQybtfUnral+IIsjuQxebz8swrKyvSuve8HLOXoJK9JKIX zLIspdDScrnMnj17FloZ67CRlU+WFVZztm9SK5bKhLHKGdoy/5SqmVH2HvTvkGVjqaJc7q0yeGhM azLBF7XAS6wyeFuQ9ouey9IoQm69ylXzWvHPnj2jmZmZ3kEii4uLvUM7VOrbeCUQqQjLxcXFO4qp VqsxfgCK8xl4uF/SlIIsAcmpeCuVCuNtc2vfJLKxsUEyheDsG64c+RyU7URVTZ2ixYjouUTvzTgk BcYubN3ODdZz2XupCPrhR2h22x3Sc1nK/J4daU2mqCNUfjrflNoTdrkF2b1FBedUnleWaHRzcyP8 bpT1hUT3lT2rSrkHv4j61evQpLDKlwdtm9vY+B3LKPozbGLPQHYmo/Wijk4+E+jzl5zEY8IgokhO 0vKjCLgpKSxziGEYiYv1ntT6QmFwcHCghTUHf9Z78jX2/Y7knwUSlccyiXWIEmUmEpmOMPWTR6PR 0GTbdT/wYy/9CuOlpSUtDAfcxsbG0Ce2RcXNzY0WNLdi0nMyhp2DfN4Fsdv3f0elQKLTLJTEOkSJ VwYguWxubmr7+/uBbZ+6rtPGxgYNc+zlzzMLAgkFLgxUXuRxE3obGxuJj1QJaw4GGfufyWXaMKtz Pu9V7+9c7CTdcczBSjyB8NpFqUw6sbulcrnMZKUluAAuFAqUyWQieSFUnoHX2PFzf37dfnK5nKcy qVQqTBTz73dHUi6XmWmaAwll/FQv5/PUajUmCkUV3TfMZ426X0XPLjsLolAohKr8p6ammMxX0A8P Z05q+YlEKANrx2Rdu0PN6jml9DTpc1nKzGXvVU6BG87qrb1JPSbO9Fqtxmzb7pkr4rCROp9hEhLS 3No3ie0Kq2/4v9FHY6IM3AQeJ6WnaVIrlXqumgRnPd/3fgEAjIaR+gwOZ5eFioDotvDa4ezyvYuo OH7xTtpmXsEV0xUAMPbK4PjFO6ZSd+c+Cj6Zgux95p4W9gMATJgyUBF491HwqR5fGXa5agAAGLky uDLPfK30RYLP73XGgWGihawdk0VxFjIAAMogElQrlMpWzIezy+zb2p6nfX0cUSnIN51fuPM7PzFt lGchAwCgDEa++u3/DlcoQRRL0lGp4Jp9eVcZpPS0dBcFAAB+GFm4oix00o3NH58Hnu3KPGOTmovg VrCP82RvzTUHY5L7AwAwocrgyjxj39bUTBqFv/+6t3WKTld3WbfdoW67Q9P5hTuF/AAAYOyVAZE8 4YyD8tUAADDhyoBIbg4xSnmshAEA4D4oAw4/uIU7QlWVwOHsMuvaHUrpaXqyuzZW5qRrq8m+re/1 nL5Bykxw3wtKVAAAJkIZBFUgTr/DuO0k3JzofoT66eoua1bPsZMCAITOWJ1n0B9W+utv4xNmKiqx 0bU7ylnImbns2LYfAABlEBoPjeneYfFGKT8xJa/b/6iV33hUeKxN5xcopacnqv0AgPhJhDCxdkxm 138e/D6hZxsEySMAAIB7oQyurSYz//jT9W+TaA938xkglBYAcO+VgVdW8iQqBJ5rkdJvj7VMkiLo 912MOlJL5Dvx+xzXVpNF9ezOZwzyXHG0bVT94bddw/RH3HMVyiBE+iNj3FCNtLm2mqz16Zzsixbp c1l6+nE9lnZdmWes9emcUpn0UM8QV3vKD54z7pPp2rdZ0EHbcji7zPwou2urybjvxK63KJVJ98KO f/0trWxG4xncUSnZw9llxosGdu0O2Rct5Tla/1AdKEqY+T3rSwCaf/zp26x4OLvM/IYhX5ln7N/v Hc/FmLVjDgh0a7uqVEXAOd84KmPdH5bOxwEZ+8PxS1w3VjmzgEfayCZVv6mpaZ/T4ewyiyMHwRn2 evziHQsikK7MM9f2jCKnIKWnB16mK/OMHV74uz9/WbvtjvKq1PkZXqo8iB+l2+6QnsvS1cto6jal Mnf76Mo8Y9b3BaYihPRcdihh1fp0Tk/21qj+oZoYAeI2X/ScmoJzm2+quPkVrfwCs3ZMBoUQjNii iVSrbXbb8s+5+Ry6didRL0xQheJsT1ylux8VHmu5N3nXFaBMaD39uK7l3uSp9el8pDuz7Mvb1eEo x39UlWO77Q49KjzWUpk0JfUci/qHamymT+NtQUMV3zFUBio1/L1Wh7IXwkuJDGsqOJxdHjhYxnnm gEpZ6qS0R2UM/JxUx/NBRr0zq3+o9uZLlALz2mqya6vJrB2TtT6dD5QX99rpOn9U72ntmIzfJ/cm n8jFzvGLd+zJ7lqgvvTbH0HfI5BAZaDyAnGboIppYVRcW03WtTs9m7qTpx/Xtc0fn7XNH5+1MM5w cBOwSed0dZc5xzYzlx3JCXVX5hnrV8ZRCMxuu0Ptf1rU+nROzeo5FU/eK481/67zR5Vm9byn6B4a 01rS5oO1Yyqbh5zKsb8/hhXkKT0d68JpnInNZ/Co8FjzqmL6ZHeNyDjy3GG4XWM6v0B0eRT6cz80 pjVuMonCJi1qj57LEp3EM1bcB6AqtJwK4N/vHfIKFAiD1qfzW1/Bz/tGJRCcPoPjF+8YXfob2yD2 bB6YcPXmP6Xa+nROSbGPc+e4X/PQMD4DmYKBz2DMdgZERMWT91p/NAGfJKpnGhRP3mv9OwiVl26Y FYjxtqAFnXBX5pl0O+zWnrijJFRNIXx1/u/3Tu9nFFt357Wd905l0r58HX7JvckLy4xEoeicbdNz 2ZEoWRXqH6qBzKJRzAP7okVgzHYGTsHKBcm/3zv/hdoZ6qv6V5dH2rXVZNzBRiefhVtZngVs/vEn lR88Z6NI+nJGPHEHsSziaaA9Hz/HNj7HL96x7MsFJcVc/1B1DbPkK8cohWXuTd71GQ9nlyMT1g+N ae34xTsWZRw/35W5LQZOV3fZ9W5091Y1D/G+iNtM9W19D5V8x1kZOM1Gw76YXkLNrRyEXW9FGrpp 7ZhMFPH0bX1PeHRlHC9XKpOm48y7npmltyM5ea+k8FqfzsnNbMJNa9dv1ARXKuPP7tttd4T9NZ1f oOvdtdAEZr+tvnjyXjsmUlI4dr01EBXmtYttX7Rud2UfB//29OO6dkreOxPnuHKyLxek71wqk76z sxPRrN7m1fS3SyU/xe25eJ96fa/+oUrHL94xXsKGL6Ig0oMzVmcB8CQovy+2rC6Q86WUTUJeP4nb 87kpR2bCkZXbcJrEMIkBAFAGCkrAeSAMkf8yFfxAHC82f3zWRLsKmaN7Or/gugpSUUJE9/vMZwBA Mkh8Cev6h+pAUo+1XfUVrqiaiOLm5FQ5t7lZPXd1JKre10+IIQAA3DtlcG01hYI4iszW/tW57P79 2BeDMdKIdwYAQBlEjB9Bq5rtPIzC4Qk0Qe6LE8sAAFAGPlbqdwTtnLqAVwkddct38Buz3L+LMN4W NK8saj2XxcE2AAAoAy+e7A3WOknp/ssquwl7p0B2c0j7Tfl3+/yryyOhQkjp6UQk6wAAwC9Jf8BH hccaj2Hn5YmDZOM6Swjww2WIws3uFQn9V5dHmjM0NaWn/7uvcYRZCACInYk7Z7hrd0g1Y9aLK/OM uZWUFoEQUQDAuPK/SWnIlXnGrO0qNavn9G19L5RaOI8KjzVVJ7Dfio0AAABlEAHOyB+38tJBcSsc 109KT+NQewAAlEES6HfEDhyJt2OyoEXLXl0eaSIHtFHKo5wEAAAkDbeSxddWk5UfPGflB8/ZsCWN r60m8ypDDQAAIKGcru66HlUJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA kPB/QoRY0PksI1MAAAAASUVORK5CYII="
        width={76.208}
        height={27.766}
        x={206.086}
        y={-77.755}
        preserveAspectRatio="none"
        style={{
          stroke: "#b3b3b3",
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
);
export default SvgFlowChartWLogo;
